export const en = {
  titleImg: 'https://contents-virtual.eventxtra.com/uploads/reed902_staging/originals/150ea938-6c44-4378-b8a2-093cba2a47bb.png',
};

export const ja = {
  titleImg: 'https://contents-virtual.eventxtra.com/uploads/reed902_staging/originals/e46064e5-c039-4c28-bdd7-f34c2f8f37bd.png',
};
